import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectQuotation = state => state.get('quotation', initialState);

const selectOfferSelector = state => state.get('offer', initialState);

const selectCustomizeOfferSelector = state =>
  state.get('customizeOfferSelector', initialState);

const makeSelectQuotation = () =>
  createSelector(selectQuotation, quotationState =>
    quotationState.get('quotation'),
  );

const makeSelectQuotationCode = () =>
  createSelector(selectQuotation, quotationState => quotationState.get('quotation').quotation.data.code);

const makeSelectProposalId = () =>
  createSelector(selectQuotation, quotationState => quotationState.get('proposal_id'));

const makeSelectDispalyAssistant = () =>
  createSelector(selectQuotation, quotationState =>
    quotationState.get('displayAssistant'),
  );

const makeSelectQuotationStatus = () =>
  createSelector(selectQuotation, quotationState =>
    quotationState.get('newStatus'),
  );

const makeSelectQuotationLoaded = () =>
  createSelector(selectQuotation, quotationState =>
    quotationState.get('quotationLoaded'),
  );

const makeSelectOfferSelector = () =>
  createSelector(selectCustomizeOfferSelector, quotationState =>
    quotationState.get('offer'),
  );

const makeSelectAccessoriesCodesSelector = () =>
  createSelector(selectCustomizeOfferSelector, quotationState =>
    quotationState.get('accessoriesCodes'),
  );

const makeSelectAccessoriesSelector = () =>
  createSelector(selectCustomizeOfferSelector, offerSelectorState =>
    offerSelectorState.get('accessories'),
  );

const makeSelectColorCodesSelector = () =>
  createSelector(selectCustomizeOfferSelector, quotationState =>
    quotationState.get('colorCodes'),
  );

const makeSelectColorsSelector = () =>
  createSelector(selectCustomizeOfferSelector, quotationState =>
    quotationState.get('colors'),
  );

const makeSelectServicesSelector = () =>
  createSelector(selectCustomizeOfferSelector, quotationState =>
    quotationState.get('services'),
  );

const makeSelectOriginalOffer = () =>
  createSelector(selectOfferSelector, quotationState =>
    quotationState.get('offer'),
  );

const makeSelectMonthlyRateSelector = () =>
  createSelector(selectCustomizeOfferSelector, quotationState =>
    quotationState.get('monthlyRate'),
  );

export {
  selectQuotation,
  makeSelectQuotation,
  makeSelectQuotationCode,
  makeSelectProposalId,
  makeSelectDispalyAssistant,
  makeSelectQuotationStatus,
  makeSelectQuotationLoaded,
  makeSelectOfferSelector,
  makeSelectAccessoriesCodesSelector,
  makeSelectAccessoriesSelector,
  makeSelectColorCodesSelector,
  makeSelectColorsSelector,
  makeSelectServicesSelector,
  makeSelectOriginalOffer,
  makeSelectMonthlyRateSelector,
};
